import { Component, effect, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';

@Component({
  selector: 'aw-label-text-input',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    ToFormControlPipe,
    AppendTestIdPipe,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './label-text-input.component.html',
})
export class LabelTextInputComponent extends FormInputComponent {
  public isEditing: InputSignal<boolean> = input<boolean>(false);
  constructor(public override ngControl: NgControl) {
    super(ngControl);
    effect((): void => {
      if (this.isEditing()) {
        document.getElementById(this.id())?.focus();
      }
    });
  }
}
